var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "none",
    stroke: "#000",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 8 C 0.5 8 3.227 2.546 8 2.546 C 12.773 2.546 15.5 8 15.5 8 C 15.5 8 12.773 13.455 8 13.455 C 3.227 13.455 0.5 8 0.5 8 Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 8 5.955 C 7.457 5.955 6.937 6.17 6.553 6.554 C 6.17 6.938 5.954 7.459 5.954 8 C 5.954 8.543 6.17 9.064 6.553 9.447 C 6.937 9.83 7.457 10.046 8 10.046 C 8.543 10.046 9.063 9.83 9.447 9.447 C 9.83 9.064 10.046 8.543 10.046 8 C 10.046 7.459 9.83 6.938 9.447 6.554 C 9.063 6.17 8.543 5.955 8 5.955 Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpened);
export default __webpack_public_path__ + "static/media/eye-opened.31172abb1b87c720a2e65ee65ec0c512.svg";
export { ForwardRef as ReactComponent };